import { BackgroundImage, Badge, Box, Button, Card, Flex, Group, Stack, Text, Title, useMantineTheme } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { useCreateChat } from 'api/chatAPI';
import { Permission, useAuth } from 'hooks/useAuth';
import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

const VendorCard = ({
    data,
}: {
    data: any,
}) => {
    const theme = useMantineTheme()
    const { user } = useAuth(Permission.ANYONE);
    const navigate = useNavigate()
    const isMd = useMediaQuery(`(max-width: ${theme.breakpoints.md})`);
    const createChatMutation = useCreateChat();

    const handleCreateChat = useCallback(async () => {
        if (!data) {
            return
        }

        console.log("data", data)
        const chat = await createChatMutation.mutateAsync({
            lister: user.id,
            agent: data.vendorPic[0].agent.id,
            vendor: data.id
        });

        navigate(`/chats`, { state: { id: chat.data.id } });
        // try {

        // } catch (e: any) {
        //     if (e?.response?.data?.error?.message === "Insufficient tokens") {
        //         setPurchaseTokensPopup(true);
        //     }
        // }
    }, [data])

    return (
        <Card withBorder shadow="md" radius={16}>
            <Stack>
                <Flex
                    gap={16}
                    sx={{
                        flexDirection: isMd ? "column" : "row"
                    }}
                >
                    <Group position='center'>
                        <Box p={8} sx={{ border: "1px solid #ddd", borderRadius: 8 }}>
                            <BackgroundImage src={data.logo?.url} h="128px" w="128px" sx={{ backgroundSize: "contain", backgroundRepeat: "no-repeat" }} />
                        </Box>
                    </Group>
                    <Stack sx={{ flex: 1 }}>
                        <Stack spacing={8} sx={{ flex: 1 }}>
                            <Title order={3}>{data.name}</Title>
                            <Text>{data.size}</Text>
                            {data.state && (<Text c="#2e523c" fw="bold">{data.state}</Text>)}
                        </Stack>
                        {data.tags && (
                            <Group
                                sx={{ flex: 1, width: "100%", alignItems: "flex-start", justifyContent: "flex-start" }}
                            >{data.tags.map((t: string) => (<Badge variant='outline'>{t}</Badge>))}</Group>
                        )}
                    </Stack>
                </Flex>
                <Stack>
                    <Text>{data.description}</Text>
                    <Button onClick={() => navigate(`/vendor/${data.slug}`)}>Learn More</Button>
                    <Button onClick={() => handleCreateChat()}>Start Chat</Button>
                </Stack>
            </Stack>
        </Card>
    );
};

export default VendorCard;